module.exports = __webpack_public_path__ + "img/no.2.a114f829.png";